import { render, staticRenderFns } from "./CustomNotifications.vue?vue&type=template&id=feb3feb2&scoped=true&"
import script from "./CustomNotifications.vue?vue&type=script&lang=js&"
export * from "./CustomNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotifications.vue?vue&type=style&index=0&id=feb3feb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb3feb2",
  null
  
)

export default component.exports